import { createFileRoute } from '@tanstack/react-router'
import { CommissionRunsPage } from '../../../../features/commissions/runs-page'
import { commissionRunSearchSchema } from '../../../../features/commissions/search'

export const Route = createFileRoute('/_app/commissions/runs/')({
  validateSearch: commissionRunSearchSchema,
  component: CommissionRunsPage,
})
